import React, { Component } from 'react';
import { BrowserRouter, Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import './App.css';

import Routes from './components/Routes';
import Nav from '../src/components/Nav';
import { firebase } from '../src/firebase';
import withAuthentication from './components/withAuthentication';

class App extends Component {

  render() {
    return (
      <BrowserRouter>
        <div>
          <div class="jumbotron">
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Link to='/'><h1 className='brand navItems'>OROMO LIVES MATTER</h1></Link>&nbsp;
              <div className="header-right-right">
                <Nav />
              </div>
            </div>

          </div>
          <Routes db={firebase} />
        </div>
      </BrowserRouter>
    );
  }
}

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/App.js